import axios from 'axios'
import { api } from '@/services/config'
import store from '@/store'
import { mixin } from '@/mixins/helper'

const mdLandingStore = {
  namespaced: true,
  state: () => ({
    isLoading: false,
    bidang_usaha_id: 1,
    type_pendaftaran_id: 1,
    step_id: 1,

    registrasi: [],
    profile: [],
    alamat: [],
    bank: [],
    afiliasi: [],
    legal_doc: [],
    finish: [],
    total_data: 0,

    form_data: {},
  }),
  mutations: {
    SET_LOADING(state, status) {
      state.isLoading = status
    },
    UPDATE_DATA(state, payload) {
      state[payload.name] = payload.value
    },
  },
  actions: {
    async getFormById({ commit, state }, payload) {
      try {
        const url = `${api}/api/v1/md-landing-forms/${payload.id}`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        state.form_data = data.data
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getAllForms({ commit, state }, payload) {
      state.bidang_usaha_id = payload.bidang_usaha_id
      state.type_pendaftaran_id = payload.type_pendaftaran_id
      state.step_id = payload.step_id

      try {
        const url = `${api}/api/v1/md-landing-forms?md_landing_step_id=${payload.step_id}&bidang_usaha_id=${payload.bidang_usaha_id}&type_pendaftaran_id=${payload.type_pendaftaran_id}&page=1&limit=100000`
        state.isLoading = true

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          state.isLoading = false
          switch (payload.step_id) {
            case 1:
              state.registrasi = data.data
              state.total_data = data.pagination.totalItems
              break
            case 2:
              state.profile = data.data
              state.total_data = data.pagination.totalItems
              break
            case 3:
              state.alamat = data.data
              state.total_data = data.pagination.totalItems
              break
            case 4:
              state.bank = data.data
              state.total_data = data.pagination.totalItems
              break
            case 5:
              state.afiliasi = data.data
              state.total_data = data.pagination.totalItems
              break
            case 6:
              state.legal_doc = data.data
              state.total_data = data.pagination.totalItems
              break
            case 7:
              state.finish = data.data
              state.total_data = data.pagination.totalItems
              break

            default:
              break
          }
        } else {
          throw new Error('Data not found')
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        state.isLoading = false
      }
    },
    async editForm({ commit, dispatch, state }, payload) {
      try {
        const url = `${api}/api/v1/md-landing-forms/${payload.id}`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'PUT',
          url,
          data: payload,
        })

        if (data && data.status == 'success') {
          await dispatch('getAllForms', {
            step_id: payload.md_landing_step_id,
            bidang_usaha_id: payload.bidang_usaha_id,
            type_pendaftaran_id: payload.type_pendaftaran_id,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
          return true
        } else {
          throw new Error('Data not found')
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async addForm({ commit, dispatch, state }, payload) {
      try {
        const url = `${api}/api/v1/md-landing-forms`
        state.isLoading = true

        const { data } = await axios({
          method: 'POST',
          url,
          data: payload,
        })

        if (data && data.status == 'success') {
          await dispatch('getAllForms', {
            step_id: payload.md_landing_step_id,
            bidang_usaha_id: payload.bidang_usaha_id,
            type_pendaftaran_id: payload.type_pendaftaran_id,
          })
          state.isLoading = false
          return true
        } else {
          throw new Error('Data not found')
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        state.isLoading = false
      }
    },
  },
}

export default mdLandingStore
